import { createContext, useContext } from "react";
import type { GalleryTreeData, SelectedGalleryNode } from "./galleryTree";

interface GalleryTreeContextValue {
  treeData: GalleryTreeData;
  expandedProjectIds: Set<string>;
  selectedNode: SelectedGalleryNode;
  selectedSessionId: string | undefined;
  onSelectProject: (projectId: string) => void;
  onToggleProject: (projectId: string) => void;
  onRenameProject: (projectId: string, name: string) => void | Promise<void>;
  onRenameSession: (sessionId: string, name: string) => void | Promise<void>;
  onMoveSessionToProject: (
    sessionId: string,
    projectId: string | null,
  ) => void | Promise<void>;
  onSessionClick: (sessionId: string) => void;
}

const GalleryTreeContext = createContext<GalleryTreeContextValue | null>(null);

export function GalleryTreeProvider({
  children,
  value,
}: {
  children: React.ReactNode;
  value: GalleryTreeContextValue;
}) {
  return (
    <GalleryTreeContext.Provider value={value}>
      {children}
    </GalleryTreeContext.Provider>
  );
}

export function useGalleryTree(): GalleryTreeContextValue {
  const ctx = useContext(GalleryTreeContext);
  if (!ctx) {
    throw new Error("useGalleryTree must be used within GalleryTreeProvider");
  }
  return ctx;
}
